import type { ReactNode } from "react";

/** A section heading with an emoji before the word. The emoji is decoration: screen readers hear only the word. */
export function SectionTitle({ emoji, children }: { emoji: string; children: ReactNode }) {
  return (
    <h2 className="section__title">
      <span className="section__emoji" aria-hidden="true">
        {emoji}
      </span>
      {children}
    </h2>
  );
}
